import { Voni } from '../client';

export interface Conflict {
  id: number;
  conversation_id: number;
  title: string;
  description: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  reported_by: number;
  assigned_to?: number;
  resolution_notes?: string;
  created_at: string;
  updated_at: string;
}

export interface ConflictCreateInput {
  conversation_id: number;
  title: string;
  description: string;
  priority?: 'low' | 'medium' | 'high' | 'critical';
}

export interface ConflictUpdateInput {
  title?: string;
  description?: string;
  priority?: 'low' | 'medium' | 'high' | 'critical';
  status?: 'open' | 'in_progress' | 'resolved' | 'closed';
  assigned_to?: number;
  resolution_notes?: string;
}

export interface ConflictListParams {
  skip?: number;
  limit?: number;
  status_filter?: string;
  priority_filter?: string;
}

export class ConflictsResource {
  constructor(private client: Voni) {}

  async list(params?: ConflictListParams): Promise<Conflict[]> {
    return this.client.request<Conflict[]>('GET', '/conflicts/', params as Record<string, unknown>);
  }

  async get(conflictId: number): Promise<Conflict> {
    return this.client.request<Conflict>('GET', `/conflicts/${conflictId}`);
  }

  async create(data: ConflictCreateInput): Promise<Conflict> {
    return this.client.request<Conflict>('POST', '/conflicts/', undefined, data);
  }

  async update(conflictId: number, data: ConflictUpdateInput): Promise<Conflict> {
    return this.client.request<Conflict>('PUT', `/conflicts/${conflictId}`, undefined, data);
  }
}
